<template>
  <div class="image-slider">
    <header-bar :back-link="backLink" />
    <vue-tiny-slider
      v-if="exhibitsLoaded"
      :mouse-drag="true"
      :loop="false"
      :items="1"
    >
      <div
        v-for="(image,index) in exhibit.data.gallery"
        :key="index"
      >
        <pinch-image :src="image.url" />
      </div>
    </vue-tiny-slider>
  </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider'
import PinchImage from '@/components/vendor/PinchImage.vue'

// ExhibitData mixin - handles loading info for the media gallery
import ExhibitData from "../mixins/ExhibitData.vue"

export default {
    name: 'ImageSlider',
    components: {
      VueTinySlider,
      PinchImage
    },
    mixins: [
        ExhibitData
    ],
    props: {
        exhibitslug: {
            type: String,
            default: null
        },
        slide: {
            type: [String,Number],
            default: 0
        },
        backLink: {
            type: [String, Object, Boolean],
            default: false
      },

    },
    computed: {
        exhibits () {
            return this.$store.getters.bySlug
        },
        exhibit () {
            return this.exhibits[this.exhibitslug]
        },
        slideNum() {
            return parseInt(this.slide)
        }
    },
    mounted() {
    },
    methods: {
        hooperLoaded() {
            // Hooper has a WEIRD WEIRD issue with our styles on iOS.
            // Adding do-nothing touchstart handler on list items
            // does SOMETHING to help this. I wish I knew WHAT.
            const childs = this.$refs.hoooper.$refs.track.children
            for (let i = 0; i < childs.length; i++) {
                childs[i].addEventListener('touchstart', () => {}, {passive: true})
            }
        }
    }
}
</script>
<style lang="scss" scoped>
// Hooper by default is quite sensible, but we need to do some tweaking.
@import '~@/assets/scss/tiny-slider';
// @import '~hooper/dist/hooper.css';
.image-slider {
    @include flex-vertical;
    background: black;
}

/deep/ .tns-outer {
  position:relative;
  &, .tns-ovh {
    @include flex-vertical;
    @include flex-fill-vertical;
  }
  .tns-inner {
    @include flex-vertical;
    @include flex-fill-vertical;
  }
  .tns-slider {
    display: flex;
    @include flex-fill-vertical;
  }
}
// .hooper {
//     background: black;
//     flex-grow: 1;
//     // Make the main Hooper container flex
//     @include flex-vertical;

//     // .hooper-list contains the scroll track. We want to make it fill the vertical flex container .hooper
//     /deep/ .hooper-list {
//         @include flex-fill-vertical;
//     }

//     // List items need to be forced "full-screen", and flex.
//     // We also align its items to the centre.
//     /deep/ li {
//         @include full-screen;
//         @include flex-vertical;
//         flex-grow: 1;
//         justify-content: center;
//         // border: 3px solid blue; // Just for testing.
//     }

//     /deep/ .hooper-slide img {
//         user-select: none;
//     }

//     /deep/ .hooper-next, /deep/ .hooper-prev {
//         svg {
//             fill: white;
//             width: 150px;
//             height: 150px;
//         }
//         top: auto;
//         bottom: 0;
//         transform: none;
//         opacity: 0.8;
//     }
// }
</style>